import React from "react";

function App() {
  return (
    <div>
      <header>CoinChums</header>
    </div>
  );
}

export default App;
